import { Flex } from 'common/flex';

interface ItalicProps {
  variant: 'h1' | 'h2';
  children: string;
  className?: string;
}

export const Italic = ({ children, variant, className }: ItalicProps) => {
  const words = children.split(' ');

  if (words.length > 1) {
    const lastWord = words.pop() || '';
    const textBefore = words.join(' ');

    return variant === 'h1' ? (
      <h1 className={className}>
        {textBefore}
        <i>{` ${lastWord}`}</i>
      </h1>
    ) : (
      <Flex gap="4px" className={className}>
        <h2>{textBefore}</h2>
        <h2 className="italic">{lastWord}</h2>
      </Flex>
    );
  }

  return variant === 'h1' ? <h1>{children}</h1> : <h2>{children}</h2>;
};
